/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

// import settings from '../../../src/settings';
'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

/* eslint id-length: 0 */

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var MostPopular = (function (_Component) {
	_inherits(MostPopular, _Component);

	function MostPopular() {
		_classCallCheck(this, _MostPopular);

		_Component.apply(this, arguments);
	}

	MostPopular.prototype.render = function render() {
		var _classNames, _classNames2, _classNames3;

		var styles = require('./MostPopular.css');

		var baseStyles = _classnames2['default']((_classNames = {}, _classNames[this.props.className] = this.props.className, _classNames[styles.Base] = !this.props.className, _classNames));

		var linkClasses = _classnames2['default']((_classNames2 = {}, _classNames2[styles.Link] = !this.props.withNumbers, _classNames2[styles['Link--withNumbers']] = this.props.withNumbers, _classNames2));

		var contentClasses = _classnames2['default']((_classNames3 = {}, _classNames3[styles.Content] = !this.props.withNumbers, _classNames3[styles['Content--withNumbers']] = this.props.withNumbers, _classNames3));

		/* Map articles from API to <article/> elements */
		var articleRoll = _lodash2['default'].map(this.props.articles, function (article) {
			return _react2['default'].createElement(
				'article',
				{ className: styles.Article, key: article.id },
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: linkClasses, to: article.url },
					_react2['default'].createElement(
						'div',
						{ className: contentClasses },
						_react2['default'].createElement(
							'header',
							{ className: styles.Header },
							_react2['default'].createElement(
								'h1',
								{ className: styles.Title },
								article.title
							)
						)
					)
				)
			);
		});

		return _react2['default'].createElement(
			'section',
			{ className: baseStyles },
			_react2['default'].createElement(_components.HeaderTab, { icon: 'star', title: 'Most Popular' }),
			_react2['default'].createElement(
				'div',
				{ className: styles.Articles },
				articleRoll
			)
		);
	};

	_createClass(MostPopular, null, [{
		key: 'propTypes',
		value: {
			articles: _react.PropTypes.array,
			className: _react.PropTypes.string,
			withNumbers: _react.PropTypes.bool
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			articleCount: 8,
			withNumbers: true
		},
		enumerable: true
	}]);

	var _MostPopular = MostPopular;
	MostPopular = _reactRedux.connect(function (state) {
		return {
			articles: state.mostPopular.data
		};
	})(MostPopular) || MostPopular;
	return MostPopular;
})(_react.Component);

exports['default'] = MostPopular;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MostPopular/MostPopular.js
 ** module id = 685
 ** module chunks = 0
 **/